import { format, differenceInHours } from "date-fns"

/**
 * Standard font family for chart axis ticks, tooltips, and legend text.
 * Matches the app's body text font (Open Sans).
 */
export const CHART_FONT_FAMILY = "OpenSans_500Medium, Open Sans, sans-serif"

export function getEvenTicks(minMs: number, maxMs: number, count = 6): number[] {
  const step = (maxMs - minMs) / (count - 1)
  return Array.from({ length: count }, (_, i) => Math.round(minMs + step * i))
}

export function formatXAxisTick(value: number, minMs: number, maxMs: number): string {
  const dateValue = new Date(value)
  const diff = differenceInHours(maxMs, minMs)
  if (diff > 24 * 7) return format(dateValue, "M/d")
  if (diff > 24) return format(dateValue, "EEE p")
  return format(dateValue, "p")
}
